import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import auth from './modules/auth';
import object from './modules/object';
import resources from './modules/resources';
import application from './modules/application';
import table from './modules/table';
import logs from './modules/logs';

import calculators from './modules/calculators';
import homevantage from './modules/homevantage';
import keyplan from './modules/keyplan';
import mycover from './modules/mycover';

export default new Vuex.Store({
    modules: {
        auth,
        object,
        resources,
        application,
        table,
        logs,

        calculators,
        homevantage,
        keyplan,
        mycover
    },

    state: {},

    getters: {},

    actions: {},

    mutations: {}
});
